import {ContentRelationshipField, isFilled, KeyTextField, LinkField} from '@prismicio/client'
import Link from 'next/link'
import {useLinkResolver} from 'prismicio'
import {ButtonDocument, PricingSectionSlice} from 'prismicio-types'
import {ButtonV2} from 'src/common/ButtonV2'
import {EVENTS, getButtonsData, track} from 'src/common/helpers'
import {Icon} from 'src/common/Icon'
import {TextLink} from 'src/common/TextLink'

export const VariationLink = ({
  variation,
  url,
  label,
  componentIndex,
  pageUid,
  primaryButton,
  buttonsData,
  secondaryButton,
}: {
  variation: PricingSectionSlice['variation']
  url?: LinkField
  label?: KeyTextField
  componentIndex: number
  pageUid: string
  primaryButton?: ContentRelationshipField<'button'>
  secondaryButton?: ContentRelationshipField<'button'>
  buttonsData?: ButtonDocument[]
}) => {
  const {linkResolver} = useLinkResolver()

  switch (variation) {
    case 'reskin':
      if (!isFilled.contentRelationship(primaryButton) && !isFilled.contentRelationship(secondaryButton)) {
        return null
      }

      const {primaryButtonData, secondaryButtonData} = getButtonsData({
        primaryButton: primaryButton,
        secondaryButton: secondaryButton,
        buttonsData,
      })

      return (
        <div className="flex w-full flex-wrap items-center justify-center gap-3">
          {primaryButtonData && (
            <ButtonV2
              className="w-fit justify-self-center uppercase"
              variant="primary"
              size="medium"
              trackingData={{
                location: `component-${componentIndex}-pricing-section`,
                dataType: 'primary-button',
                pageName: pageUid,
                mktgId: primaryButtonData?.marketing_id || 'pricing-section-button',
              }}
              href={linkResolver(primaryButtonData?.link)}
            >
              {primaryButtonData?.label}
            </ButtonV2>
          )}
          {secondaryButtonData && (
            <Link
              href={linkResolver(secondaryButtonData?.link)}
              className="group relative mt-2 flex h-[38px] w-fit items-center gap-[14px] self-center rounded-[4px] border border-moss-grey-150 bg-moss-white pl-[14px] pr-[7px] hover:bg-moss-grey-100"
              onClick={() =>
                track({
                  event: EVENTS.CLICK,
                  mktgId: secondaryButtonData?.marketing_id || 'pricing-section-button',
                  location: `component-${componentIndex}-pricing-section`,
                  pageName: pageUid,
                  dataType: 'button',
                })
              }
            >
              <span className="text-button-s uppercase text-black">{secondaryButtonData?.label}</span>
              <div className="flex h-6 w-6 items-center justify-center rounded-sm bg-green-neon group-hover:bg-green-neon/[80%]">
                <Icon name="arrow" className="h-2 w-2.5 text-green-dark" />
              </div>
            </Link>
          )}
        </div>
      )
    default:
      if (!isFilled.link(url) || !isFilled.keyText(label)) {
        return null
      }

      return (
        <div className="pt-2 text-center">
          <TextLink field={url} label={label!} />
        </div>
      )
  }
}
